import i18n from 'i18next';
import locales from '../locales/';
import getLocaleToUse from '../locales/determine';
import { Logger } from './Logger';

const locale = getLocaleToUse();

const init = i18n
  .init({
    preload: [
      'en',
    ],
    resources: locales,
    ns: ['common'],
    lng: locale,
    defaultNS: ['common'],
    fallbackLng: ['en-AU'],
    fallbackNS: ['common'],
    saveMissing: true,
    missingKeyHandler(lng, ns, key, fallbackValue) {
      // todo: maybe this should be a dev-time error
      Logger.debug(`Key ${ns}/${key} is missing for language ${lng}`);
    },
  });

init
  .then(() => Logger.debug('i18n initialized'))
  .catch((e) => Logger.notify(e));

export default i18n;
